import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/icons/fb-min.svg'
import _imports_1 from '@/assets/icons/inst-min.svg'
import _imports_2 from '@/assets/icons/tiktok-min.svg'


const _hoisted_1 = {
  key: 0,
  src: _imports_0,
  class: "type-icon"
}
const _hoisted_2 = {
  key: 1,
  src: _imports_1,
  class: "type-icon"
}
const _hoisted_3 = {
  key: 2,
  src: _imports_2,
  class: "type-icon"
}

import phSvg from '@/assets/avatar-placeholder.svg'

export default /*#__PURE__*/_defineComponent({
  __name: 'VAvatar',
  props: {
    src: null,
    type: null
  },
  setup(__props: any) {

const props = __props as { src?: string | null, type?: number }




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "v-avatar",
    style: _normalizeStyle({ backgroundImage: props.src? `url(${props.src})`: `url(${_unref(phSvg)})` })
  }, [
    (props.type === 1)
      ? (_openBlock(), _createElementBlock("img", _hoisted_1))
      : (props.type === 2)
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : (props.type === 3)
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : _createCommentVNode("", true)
  ], 4))
}
}

})